import { environment } from 'src/environments/environment';

export type ProtectedRoute = { path: any[]; label: string; roles: string[] };

/**
 * protectedRoutes is all routes that require authentication. This object
 * is commonly used for retrieving the available routes for a user
 * based on their roles.
 */
export const protectedRoutes: Record<string, ProtectedRoute> = {
  time: {
    path: ['/time'],
    label: 'Time',
    roles: [
      environment.roles.timeTracker,
      environment.roles.invoicer,
    ],
  },
  forecasts: {
    path: ['/forecasts'],
    label: 'Forecast',
    roles: [environment.roles.timeTracker, environment.roles.invoicer, environment.roles.forecaster]
  },
  availabilities: {
    path: ['/availabilities'],
    label: 'Availability',
    roles: [environment.roles.timeTracker, environment.roles.invoicer],
  },
  users: {
    path: ['/users'],
    label: 'Users',
    roles: [environment.roles.invoicer],
  },
  clients: {
    path: ['/clients'],
    label: 'Clients',
    roles: [environment.roles.invoicer],
  },
  services: {
    path: ['/services'],
    label: 'Services',
    roles: [environment.roles.invoicer],
  },
  report: {
    path: ['/report'],
    label: 'Report',
    roles: [environment.roles.invoicer],
  },
};
